export function isLegacyScopedModifier(modifier) {
    const kind = modifier?.scope?.kind
    return !!kind && kind !== "whole-regime"
}

export function formatRateCardModifierScope(scope, tradeOptions) {
    if (!scope?.kind || scope.kind === "whole-regime") return "Whole regime"
    if (scope.kind === "trade") return `Trade: ${findTradeLabel(scope.value, tradeOptions)}`
    if (scope.kind === "facility") return `Facility: ${scope.value || "-"}`
    return scope.kind
}

export function describeLegacyRateCardModifierScope(scope, tradeOptions) {
    if (!scope?.kind || scope.kind === "whole-regime") return ""
    if (scope.kind === "trade") return ` for trade ${findTradeLabel(scope.value, tradeOptions)}`
    if (scope.kind === "facility") return ` for facility ${scope.value || "not selected"}`
    return ` for ${scope.kind}`
}

function findTradeLabel(tradeId, tradeOptions) {
    for (const trade of tradeOptions || []) {
        if (trade.id === tradeId) return trade.label
    }
    return tradeId || "not selected"
}
